import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useCallContext } from '../../../context/call/CallProvider'

import Lobby from './Lobby'
import Room from './Room'
import UnsupportedBrowserWarning from './UnsupportedBrowserWarning'

type TParams = {
	id: string
}

function Call({
	match: {
		params: { id },
	},
}: RouteComponentProps<TParams>) {
	const { call } = useCallContext()

	return (
		<UnsupportedBrowserWarning>{call.call && call.callToken ? <Room /> : <Lobby id={id} />}</UnsupportedBrowserWarning>
	)
}

export default Call
